/**
 * Location Filter Menu
 */

import { ChevronDownIcon, ChevronUpIcon, CloseIcon } from "@chakra-ui/icons";
import { Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { jobPayloadState, savedJobPayloadState } from "_state/atoms/AppAtoms";

import _ from "lodash";
import { FC, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { SecondaryButton } from "../HJSButton";
import { useGetUserProfileQuery } from "queries";
import { distances } from "config/Consts";

const LocationMenu: FC<{ index?: number }> = ({ index }) => {
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";
  const [showX, setShowX] = useState(false);

  const [payload, setPayload] = useRecoilState(jobPayloadState);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const { data: userData } = useGetUserProfileQuery();

  const getPayload = isJobSearch ? payload : savedJobPayload;
  const updatePayload = isJobSearch ? setPayload : setSavedJobPayload;

  return (
    <Menu matchWidth={true}>
      {({ isOpen, onClose }) => (
        <>
          <MenuButton
            as={SecondaryButton}
            fontSize={{ base: 14, md: 16 }}
            borderLeft="2px solid white"
            borderRadius="initial"
            rightIcon={
              isOpen ? (
                <ChevronUpIcon className="fill-white" />
              ) : (
                <ChevronDownIcon className="fill-white" />
              )
            }
            maxHeight="1.5rem"
          >
            <Text color="white" fontSize={{ base: 14, md: 16 }}>
              Location
            </Text>
          </MenuButton>
          <MenuList
            backgroundColor="teal.600"
            color="white"
            minW="initial"
            border="none"
            zIndex={20}
          >
            {distances.map((distance, idx) => {
              const value = Number(distance.split(" ")[0]);
              return (
                <MenuItem
                  key={distance}
                  backgroundColor={
                    getPayload?.distance === value
                      ? "hjsSecondaryHover !important"
                      : "teal.600 !important"
                  }
                  fontSize={{ base: 14, md: 16 }}
                  fontWeight="semibold"
                  _hover={{ backgroundColor: "hjsSecondaryHover !important" }}
                  onClick={() => {
                    if (getPayload?.distance !== value) {
                      !showX && setShowX(true);
                      updatePayload((prev: any) => ({
                        ...prev,
                        distance: value,
                        zipcode: userData?.zipcode,
                        page: 1,
                      }));
                    }
                  }}
                >
                  {distance}
                </MenuItem>
              );
            })}
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default LocationMenu;
